import { useState } from "react";
import "./_ProductSideNav.scss";
import "./_ProductSideNavMobile.scss";
import { setRedirect } from "../../../utils/_redirect";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

function _ProductSideNav({
  sidenavstructure,
  activeSideNav,
  setActiveSideNav,
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {/* Toggle button (mobile) */}
      <button
        className={`prod-sidenav-toggle ${open ? "open" : "closed"}`}
        onClick={() => setOpen((s) => !s)}
        aria-expanded={open}
        aria-label={open ? "Close sidebar" : "Open sidebar"}
      >
        {open ? <FaChevronLeft /> : <FaChevronRight />}
      </button>

      <aside className={`ad-prod-sidenav-container ${open ? "open" : ""}`}>
        {sidenavstructure.map((item, index) => (
          <div
            className={`prod-sidenav-item-wrapper ${
              activeSideNav === index ? "activeSideNav" : ""
            }`}
            key={index}
            onClick={() => {
              setActiveSideNav(index);
              setRedirect(2, index);
              // close on mobile after selection
              if (window.innerWidth <= 600) setOpen(false);
            }}
          >
            <span>{item} </span>
          </div>
        ))}
      </aside>
    </>
  );
}

export default _ProductSideNav;
